export const SERVER_API = 'http://110.8.21.39:8000/';
export const DABEEO_COLOR = "#0a1742";
